module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('account-form', {
    attrs: {
      "info": _vm.info,
      "current": _vm.current,
      "brandList": _vm.brandList,
      "storeList": _vm.storeList,
      "posList": _vm.posList
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0134849a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Account/UpAccount.vue
// module id = 2294
// module chunks = 1